import type { ControlsConfig } from './types'

export function balanceControls({
  left = [],
  right = [],
}: Partial<ControlsConfig>): ControlsConfig {
  const maxLength = Math.max(left.length, right.length)
  return {
    left: [...left, ...Array(maxLength - left.length).fill(null)],
    right: [...Array(maxLength - right.length).fill(null), ...right],
  }
}
